import React, { useEffect, useState, useRef } from 'react';
import { Form } from 'react-bootstrap';
import Grid from '@material-ui/core/Grid';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import { HospitalApi, MemberApi } from '../../apis/index.js';

const MemberUpdate = (props) => {
  const id = props.match.params.id;
  const [member, setMember] = useState({
    email: '',
    hospitalId: '',
    img: '',
    lastName: '',
    name: '',
    phoneNumber: '',
  });

  const [file, setFile] = useState({});

  useEffect(() => {
    const getMember = async () => {
      const res = await MemberApi.getMemberDetail(id);
      if (res.statusCode === 200) {
        const res1 = await HospitalApi.getHospitalID(res.data.hospitalId);
        if (res1.statusCode === 200) {
          setMember({ ...res.data, hospitalName: res1.data.name });
        } else {
          window.close();
          alert(`${res1.statusCode} ${res1.message}`);
        }
      } else {
        window.close();
        alert(`${res.statusCode} ${res.message}`);
      }
    };
    getMember();
  }, [id]);

  const changeValue = (e) => {
    setMember({
      ...member,
      [e.target.name]: e.target.value,
    });
  };

  const updateMember = async () => {
    const formData = new FormData();

    formData.append('email', member.email);
    formData.append('files', file);
    formData.append('hospitalId', member.hospitalId);
    formData.append('lastName', member.lastName);
    formData.append('memberId', member.memberId);
    formData.append('name', member.name);
    formData.append('phoneNumber', member.phoneNumber);

    const res = await MemberApi.updateMember(member.memberId, formData);
    if (res.statusCode === 200) {
      window.close();
    } else {
      alert('회원수정실패');
    }
  };

  const onchangeImageUpload = (e) => {
    const { files } = e.target;
    const uploadFile = files[0];
    const reader = new FileReader();
    reader.readAsDataURL(uploadFile);
    reader.onloadend = () => {
      setFile(uploadFile);
      setMember({ ...member, profileImgUrl: reader.result });
    };
    setFile(uploadFile);
    setMember({ ...member, profileImgUrl: reader.result });
  };

  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current.click(); // 숨겨진 file input을 프로그래밍 방식으로 클릭
  };

  const deleteImga = () => {
    setFile(null);
    setMember({ ...member, profileImgUrl: null });
  };

  return (
    <>
      <style>
        {`
        .form-control::placeholder {
          color: #B6BCC5;
          }
        }
        `}
      </style>
      <div
        style={{
          fontWeight: '700',
          fontSize: '30px',
          color: '#495057',
          marginBottom: '20px',
        }}
      >
        EDIT DOCTOR INFORMATION
      </div>
      <Form onSubmit={updateMember} onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}>
        <Form.Group>
          <Form.Label>Hospital</Form.Label>
          <Form.Control
            type="text"
            name="hospitalName"
            value={member.hospitalName}
            disabled={true}
          />
        </Form.Group>
        <Form.Group style={{ display: 'flex' }}>
          <div style={{ marginRight: '5px', width: '50%' }}>
            <Form.Label>Name</Form.Label>
            <span style={{ color: 'red' }}> *</span>
            <Form.Control
              type="text"
              placeholder="Enter member name..."
              name="name"
              autoComplete="off"
              required
              onChange={changeValue}
              value={member.name}
            />
          </div>
          <div style={{ marginLeft: '5px', width: '50%' }}>
            <Form.Label>Last Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter member last name..."
              name="lastName"
              autoComplete="off"
              onChange={changeValue}
              value={member.lastName}
            />
          </div>
        </Form.Group>
        <Form.Group style={{ display: 'flex' }}>
          <div style={{ marginRight: '5px', width: '85%' }}>
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter member email..."
              name="email"
              autoComplete="off"
              required
              onChange={changeValue}
              value={member.email}
              disabled={true}
              maxLength={100}
            />
          </div>
          <div style={{ marginLeft: '5px', width: '15%' }}>
            <Form.Label>Status</Form.Label>
            <Form.Control
              type="text"
              placeholder=""
              name="Status"
              autoComplete="off"
              required
              onChange={changeValue}
              value={member.verified}
              disabled={true}
            />
          </div>
        </Form.Group>
        {/* <Form.Group>
          <Form.Label>Phone Number</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter member phone number..."
            name="phoneNumber"
            autoComplete="off"
            required
            onChange={changeValue}
            value={member.phoneNumber}
          />
        </Form.Group> */}
        <Form.Group controlId="formBasicPassword">
          <Form.Label>Profile Picture</Form.Label>
          <div
            style={{
              width: '250px',
              height: '250px',
              border: '1px solid #B6BCC5',
              borderRadius: '4px',
              backgroundColor: '#FFF',
              boxSizing: 'border-box',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {member.profileImgUrl ? (
              <div
                style={{
                  position: 'relative',
                  width: '240px',
                  height: '240px',
                }}
              >
                <img
                  alt="" // Add this line to fix the error
                  src={member.profileImgUrl}
                  img="img"
                  style={{
                    display: 'block',
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                  }}
                />
                <button
                  style={{ position: 'absolute', top: '10px', right: '10px' }}
                  onClick={deleteImga}
                >
                  <CancelRoundedIcon
                    sx={{
                      fontSize: {
                        xs: '25px',
                      },
                      color: 'red',
                    }}
                  />
                </button>
              </div>
            ) : (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'column',
                }}
              >
                <div>
                  <CloudUploadIcon
                    sx={{
                      fontSize: {
                        xs: '50px',
                      },
                    }}
                  />
                </div>
                <div>Upload File</div>
                <div style={{ paddingTop: '10px', fontSize: '12px' }}>
                  *Max file size: 5MB
                </div>
                <div style={{ fontSize: '12px' }}>*JPG, GIF, PNG</div>
              </div>
            )}
          </div>
          <input
            style={{
              display: 'none',
            }}
            type="file"
            accept="image/*"
            onChange={onchangeImageUpload}
            placeholder="CHOOSE IMAGES"
            ref={fileInputRef}
          />
          <button
            onClick={handleButtonClick}
            style={{
              marginLeft: '35px',
              marginTop: '10px',
              outline: 'none',
              width: '170px',
              height: '38px',
              background: '#fff',
              color: '#3f598c',
              fontSize: '15px',
              fontWeight: '500',
              borderRadius: '5px',
              border: '2px solid #3f598c',
              cursor: 'pointer',
            }}
          >
            CHOOSE IMAGES
          </button>
        </Form.Group>
        <Form.Group style={{ display: 'flex' }}>
          <div style={{ marginRight: '5px', width: '50%' }}>
            <Form.Label>Date Created</Form.Label>
            <Form.Control
              type="text"
              placeholder="insertDate"
              onChange={changeValue}
              name="insertDate"
              value={member.insertDate}
              disabled
            />
          </div>
          <div style={{ marginLeft: '5px', width: '50%' }}>
            <Form.Label>Created By</Form.Label>
            <Form.Control
              type="text"
              placeholder="insertId"
              onChange={changeValue}
              name="insertId"
              value={member.insertId}
              disabled
            />
          </div>
        </Form.Group>

        <Form.Group style={{ display: 'flex' }}>
          <div style={{ marginRight: '5px', width: '50%' }}>
            <Form.Label>Date Modified</Form.Label>
            <Form.Control
              type="text"
              placeholder="modifyDate"
              onChange={changeValue}
              name="modifyDate"
              value={member.modifyDate}
              disabled
            />
          </div>
          <div style={{ marginLeft: '5px', width: '50%' }}>
            <Form.Label>Modified By</Form.Label>
            <Form.Control
              type="text"
              placeholder="modifyId"
              onChange={changeValue}
              name="modifyId"
              value={member.modifyId}
              disabled
            />
          </div>
        </Form.Group>

        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          style={{ marginTop: 30 }}
        >
          <Grid>
            <button color="primary" onClick={updateMember}>
              Update
            </button>
          </Grid>
        </Grid>
      </Form>
    </>
  );
};

export default MemberUpdate;
